import { MenuTypes as Type } from '../../../types/menu';

const initialState = {
  categories: null,
  loading: false,
  error: null,
};

const CategoriesReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case Type.GET_CATEGORY_LIST_REQUEST:
      return { ...state, loading: true, error: null, categories: null };
    case Type.GET_CATEGORY_LIST_REQUEST_SUCCESS:
      return {
        ...state,
        categories: action.payload,
        loading: false,
      };
    case Type.GET_CATEGORY_LIST_REQUEST_FAILURE:
      return { ...state, error: action.error, loading: false, categories: null };
    default:
      return state;
  }
};

export default CategoriesReducer;
